<template>
  <div class="pb-6">
    <field-label :field="field"></field-label>

    <v-btn-toggle group class="d-block" :value="value" mandatory @change="input">
      <v-btn small value="0">No</v-btn>
      <v-btn small value="1">Yes</v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import FieldLabel from '@/components/editor/partials/FieldLabel'

export default {
  name: 'ToggleField',
  props: ['value', 'field'],
  components: {
    FieldLabel
  },
  computed: {
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    }
  },
  methods: {
    input(value) {
      this.$emit('update:value', value)
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if (this.value === undefined && this.field.default !== undefined) {
      //   this.input(this.field.default)
      // }
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>
